<template lang="pug">
  .component-tabbed-vehicle-map-position(v-if="vehicle")
    .action-bar
      .title
        h2 Vehicle Position {{vehicle.vehicle_slot_address}}  {{vehicle.has_reservation ? ' - ' + vehicle.has_reservation : '' }}
    .wrap
      GoogleMapContainer
        GoogleMap(:center="{lat:vehicle.position.latitude, lng:vehicle.position.longitude}", :api-key="mapsAPI", :searchBar="true", :zoom="17", :zoomControl="true", :mapTypeControl="true")
          GoogleMapMarker(:position="{lat:vehicle.position.latitude,lng:vehicle.position.longitude}", :title='vehicle.model', :label="vehicle.model" :icon="vehicleInRange(vehicle)",)
          GoogleMapCircle(:position="{lat:vehicle.parking_lot.position.latitude,lng:vehicle.parking_lot.position.longitude}")


</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import GoogleMap from '../../../lib/map/GoogleMap.vue'
  import GoogleMapMarker from '../../../lib/map/GoogleMapMarker.vue'
  import GoogleMapCircle from '../../../lib/map/GoogleMapCircle.vue'
  import GoogleMapContainer from '../GoogleMapContainer'

  export default {
    name: 'TabbedVehicleMapPosition',
    components: {
      GoogleMapContainer,
      GoogleMap,
      GoogleMapMarker,
      GoogleMapCircle
    },
    data() {
      return {
        vehicle: null
      }
    },
    created() {
      this.loadVehiclePosition()
    },
    methods: {
      loadVehiclePosition() {
        KeplerBackofficeSdk.vehicles.select(this.$route.params.id).get((data) => {
          this.vehicle = data
        })
      },
      vehicleInRange(vehicle) {
        let icon = '/static/map_pin_blue.png'
        if (!vehicle.in_range) {
          icon = '/static/map_pin_red.png'
        }

        if(vehicle.has_reservation === 'normal') {
          icon = '/static/map_pin_orange.png'
        }

        if(vehicle.has_reservation === 'maintenance') {
          icon = '/static/map_pin_yellow.png'
        }

        if (vehicle.ev_plug_status === 'CHARGING'){
          icon = '/static/charging.svg'
        }

        return icon
      },
    },
    computed: {
      mapsAPI: function () {
        return window.env.GOOGLE_MAPS_KEY
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-vehicle-map-position
    width: 100%
    padding-bottom: 25px

    .wrap
      height: 468px

</style>



// WEBPACK FOOTER //
// VehicleMapPosition.vue?75ee24da